var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents-list" },
    [
      _c("div", { staticClass: "documents-list__title title" }, [
        _c("div", { staticClass: "title__text" }, [
          _vm._v("Перечень документов"),
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "title__download-all",
            attrs: { href: _vm.archiveDownloadLink, download: "" },
          },
          [
            _c("span", [_vm._v("Скачать все документы")]),
            _vm._v(" "),
            _c("img", {
              attrs: {
                src: require("../../assets/icons/documents/download.svg"),
                alt: "download.svg",
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _vm.isLoading
        ? _c("div", { staticClass: "contract-history__loader-overlay" }, [
            _c("img", {
              staticClass: "contract-history__loader-icon",
              attrs: { src: require("@icons/bubble-loader.svg"), width: "40" },
            }),
          ])
        : [
            _vm._l(_vm.documentGroups, function (group, key) {
              return _c(
                "div",
                {
                  key: key,
                  staticClass: "documents-list__group documents-list-group",
                },
                [
                  _c("div", { staticClass: "documents-list-group__title" }, [
                    _vm._v(_vm._s(key)),
                  ]),
                  _vm._v(" "),
                  _vm._l(group, function (document) {
                    return _c(
                      "div",
                      {
                        key: document.id,
                        staticClass: "documents-list__item documents-list-item",
                      },
                      [
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "documents-list-item__title" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(document.name) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "documents-list-item__date" },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm._f("localDateLong")(document.date)
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("FileDownloadIcon", {
                          staticClass: "documents-list-item__link",
                          attrs: { "file-id": document.file.id },
                        }),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            _vm._v(" "),
            _vm._m(0),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        staticClass: "documents-list__rules-link",
        attrs: {
          href: "https://1cbo.ru/rates_and_services/offer2/",
          target: "_blank",
        },
      },
      [
        _c("span", [_vm._v("Правила обслуживания")]),
        _vm._v(" "),
        _c("img", {
          attrs: {
            src: require("@icons/external-link.svg"),
            alt: "external-link.svg",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }